import { app } from '../../../../app';

app.component('requestCenterPolicies', {
    bindings: {
        policies: '<',
        defaultPolicy: '<',
        companyId: '<',
    },
    templateUrl: require('./approval-policies.html'),
});



// WEBPACK FOOTER //
// ./src/portal/states/company/request-center/policies/approval-policies.component.js